import { React } from "react"
import SidebarDashboardSupervisor from "../Homepage/sidebars/SidebarDashboardSupervisor"

export default function OrderedReports() {
  return (
    <div className="layout-with-sidebar">
      <SidebarDashboardSupervisor />
      <div className="my-dashboard-wrapper">
        <h1>Ordered Reports</h1>
      </div>
    </div>
  )
}
